import TimeTriggers from './timeTriggers.ui'

export default TimeTriggers
